import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPencilAlt, faEdit } from '@fortawesome/free-solid-svg-icons';
import { Row, Col } from 'reactstrap';
export default function FichaPrefeituraContainer({ prefeitura, editPrefeitura, editMunicipios, editUsuarioResponsavel }) {

    return (
        <div style={{ color: "#666" }}>
            <h5 className="bg-gradient bg-primary p-2 rounded-3 d-flex align-items-center justify-content-between" style={{ color: "#fff" }}> <span><FontAwesomeIcon icon={faPencilAlt} /> Identificação da prefeitura </span>{editPrefeitura && <button onClick={editPrefeitura} style={{ color: "#fff", border: "none", background: "transparent" }}><FontAwesomeIcon icon={faEdit} /></button>}</h5>
            <Row>
                <Col md="12" lg="6">
                    <p><span className="fw-bold">Fantasia: </span> {prefeitura.fantasia}</p>
                </Col>
                <Col md="12" lg="6">
                    <p><span className="fw-bold">Logotipo: </span> {prefeitura.logotipo ? "Com logotipo" : "Sem logotipo"}</p>
                </Col>
                <Col md="12" lg="6">
                    <p><span className="fw-bold">Status: </span> {prefeitura.status}</p>
                </Col>
                <Col md="12" lg="6">
                    <p><span className="fw-bold">E-mail em Cópia: </span> {prefeitura.emailCC}</p>
                </Col>
            </Row>
            <Row>
                <Col md="12" lg="12">
                    <p><span className="fw-bold">Responsável pelo cadastro dos geradores: </span> {prefeitura.quemCadastraGeradores}</p>
                </Col>
                <Col md="12" lg="12">
                    <p><span className="fw-bold">Responsável pelo cadastro de contratos: </span> {prefeitura?.quemCadastraContrato ?? ""}</p>
                </Col>
                <Col md="12" lg="12">
                    <p><span className="fw-bold">Imprimir 2ª Via do Ticket na coleta do gerador? </span> {prefeitura.imprimi2ViaTicketColeta ? "Sim" : "Não"}</p>
                </Col>
                <Col md="12" lg="12">
                    <p><span className="fw-bold">Obrigatório capturar foto na "Não Coleta"?</span> {prefeitura.obrigatorioFotoNaoColeta ? "Sim" : "Não"}</p>
                </Col>
                <Col md="12" lg="12">
                    <p><span className="fw-bold">Requer Análise de PGRS?</span> {prefeitura.analisePGRS ? "Sim" : "Não"}</p>
                </Col>
                <Col md="12" lg="12">
                    <p><span className="fw-bold">Notificar Coleta Sem PGRS?</span> {prefeitura.notificarColetaSemPGRS ? "Sim" : "Não"}</p>
                </Col>
                <Col md="12" lg="12">
                    <p>
                        <span className="fw-bold">Termo auto-cadastro gerador: </span>
                        {prefeitura.termoAceite?.trim() || "Não cadastrado"}
                    </p>
                </Col>
            </Row>
            <Row>
                {prefeitura.logotipo &&
                    <Col md={"12"} lg={"12"} className="text-center">
                        <img width="300px" id="img_logotipo" src={"data:image/png;base64," + prefeitura.logotipo}></img>
                    </Col>
                }
            </Row>

        </div>

    );
}